import { bindable, BindingMode } from 'aurelia';

export class DestinationFilterContent {

    @bindable({ mode: BindingMode.twoWay }) selected = [];
    @bindable options;
    textFilter = "";
    
    RESOURCE_BASE_URL = aurelia_options.resourceBaseUrl;
    aurelia_options = aurelia_options;

    constructor() { }

    optionCountryClicked(destination) {
        if (this.selected.includes(destination.country.value)) {
            this.selected = this.selected.filter(x => ![destination.country.value, ...destination.resorts.map(y => y.value)].includes(x));
        } else {
            this.selected = [...this.selected, destination.country.value, ...destination.resorts.map(x => x.value).filter(x => !this.selected.includes(x))];
        }
    }

    optionResortClicked(destination, resort) {
        let newSelection = [];
        if (this.selected.includes(resort.value)) {
            newSelection = this.selected.filter(x => resort.value !== x);
        } else {
            newSelection = [...this.selected, resort.value];
        }
        if (! newSelection.includes(destination.country.value) && destination.resorts.every(x => newSelection.includes(x.value))) {
            newSelection.push(destination.country.value);
        } else if (newSelection.includes(destination.country.value) && !destination.resorts.every(x => newSelection.includes(x.value))) {
            newSelection = newSelection.filter(x => x !== destination.country.value);
        }
        this.selected = newSelection;
    }

}
